<template>
  <div class="container">
    <div class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="平台/站点">
            <el-input style="width:200px" v-model="formInline.name" placeholder="请输入平台或站点名称" clearable />
          </el-form-item>
          <el-form-item label="店铺名称">
            <el-input style="width:200px" v-model="formInline.shopName" placeholder="请输入店铺名称" clearable />
          </el-form-item>
          <el-form-item label="启用状态">
            <el-select
                @clear="formInline.status=''"
                style="width:200px"
                v-model="formInline.status"
                clearable
                placeholder="请选择店铺状态"
            >
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column
              label="平台名称"
              min-width="80"
              prop="platformName"
          ></el-table-column>
          <el-table-column
              label="站点名称"
              min-width="100"
              prop="amazonsite"
          ></el-table-column>
          <el-table-column
              label="店铺名称"
              min-width="100"
              prop="shopName"
          ></el-table-column>
          <el-table-column
              label="默认年限"
              min-width="100"
              prop="shopDefaultYear"
          ></el-table-column>
          <el-table-column
              label="状态"
              min-width="100"
              prop="status"
          >
            <template #default="scope">
              <el-switch  disabled v-model="scope.row.status" />
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              min-width="80"
              prop="addServices"
          >
            <template #default="scope">
              <el-button  link type="primary" size="small" @click="openEidt(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
      <addShopList ref="addShopList" @close="close"></addShopList>
    </div>
  </div>
</template>
<script>
import {ElButton, ElForm, ElFormItem, ElInput, ElPagination,
  ElSwitch, ElTable, ElTableColumn,ElSelect,ElOption} from "element-plus";
import addShopList from "@/components/addShopList.vue";
import {getBaseShopList} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
export default {
  name: "shopList",
  mixins:[DynamicHeightMixin],
  components: {
    ElForm,ElFormItem,ElButton,ElInput,ElTable,
    ElSwitch,
    ElTableColumn,ElPagination,ElSelect,ElOption,addShopList
  },
  data(){
    return{
      currentPage:1,
      pageSize:20,
      pageTotal:0,
      formInline:{},
      tableData:[],
      options:[
        {
          value: 1,
          label: '正常',
        },
        {
          value: 2,
          label: '禁用',
        },
      ]
    }
  },
  beforeMount() {
    this.getPlatform()
  },
  methods:{
    onSubmit(){
        this.PageNumber = 1
      this.getPlatform()
    },
    getPlatform(){
      getBaseShopList({PageNumber:this.currentPage,
        PageSize:this.pageSize,...this.formInline}).then(res => {
        console.log(res)
        this.tableData = res.Data
        this.pageTotal = res.count
      }).catch(err=>{
        console.log(err)
      })
    },
    openEidt(data){
      this.$refs.addShopList.open(data)
    },
    close(){
      this.getPlatform()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getPlatform();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getPlatform();
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container .el-form-item{
  margin-bottom:0!important;
}
</style>